import { ReviewOffer } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import { hasAnnualSelfSupplyData } from "./selfSupplyChartData";
import { shouldShowOfferReviewSystemComparison } from "./shouldShowOfferReviewSystemComparison";
import {
  BACKUP_ID,
  STANDALONE_BUNDLE_ID,
  STANDALONE_PRODUCT_ID,
  STORAGE_ADDON_BUNDLE_ID,
  STORAGE_ADDON_PRODUCT_ID,
} from "constants/bundleAndProductIds";

const OFFER_REVIEW_BATTERY_PRODUCT_IDS = [
  STORAGE_ADDON_BUNDLE_ID,
  STORAGE_ADDON_PRODUCT_ID,
  BACKUP_ID,
  STANDALONE_BUNDLE_ID,
  STANDALONE_PRODUCT_ID,
];

const offerReviewOfferHasBattery = (
  offer: ReviewOffer | undefined
): boolean => {
  if (!offer) {
    return false;
  }

  return [...(offer.includedProducts ?? []), ...(offer.accessoryProducts ?? [])]
    .map((product) => product.productId)
    .some((productId) => OFFER_REVIEW_BATTERY_PRODUCT_IDS.includes(productId));
};

/** Simplified offer review — solar + battery full systems with self-supply data; not second systems. */
const shouldShowSimplifiedOfferReviewPage = (
  offer: ReviewOffer | undefined
): boolean => {
  if (!offer) {
    return false;
  }

  if (offer.additionalSystem) {
    return false;
  }

  if (!hasAnnualSelfSupplyData(offer)) {
    return false;
  }

  return shouldShowOfferReviewSystemComparison({
    offer,
    nonSolarView: Boolean(offer.isNonSolar),
    hasBattery: offerReviewOfferHasBattery(offer),
  });
};

export { offerReviewOfferHasBattery, shouldShowSimplifiedOfferReviewPage };
